import styled from 'styled-components';
import { Button } from '../../../../styles/globalComponents';

export const Container = styled.div`
    width: 200px;
    height: 130px;
    display: flex;
    padding-top: 10px;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    color: #fff;
    font-size: 12px;
    position: absolute;
    top: 150px;
    right: 0;
    bottom: 0;
    z-index: 4;
    background-color: #111;

    &.active {
        top: 20px;
    }

    & ${Button} {
        margin: 0 0 10px 0;
        min-height: 30px;
    }
`;